<template>
  <UiAppBar
    :height="40"
    :style="{
      transform: `translateY(${
        isScrollingBottom ? 'calc(var(--header-height) * -1)' : '0'
      })`,
    }"
    class="ui-header"
  >
    <UiContainer class="ui-header__container">
      <slot />
    </UiContainer>
  </UiAppBar>
</template>

<script setup lang="ts">
import { UiContainer, UiAppBar } from '~/ui';
import { useScroll } from '~/infrastructure/composables';

const { isScrollingBottom } = useScroll();
</script>

<style lang="scss" scoped>
.ui-header {
  background-color: rgb(var(--v-theme-header-bg-color));
  color: rgb(var(--v-theme-header-text-color));
}

.ui-header__sheet,
.ui-header__container {
  height: 100%;
}

.ui-header__container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>

<style lang="scss" scoped>
:deep(.v-container) {
  padding: 0;
}
</style>
